import { EAuthenticateStatus, ECreateStatus, EMergeStatus, ESocialType } from '../../types/social';
export var defaultState = {
  socialType: null,
  socialLoginId: null,
  email: null,
  phone: null,
  authenticate: {
    status: EAuthenticateStatus.Initial
  },
  create: {
    status: ECreateStatus.Initial
  },
  merge: {
    status: EMergeStatus.Initial,
    email: '',
    socialType: ESocialType.VK,
    socialLoginId: ''
  },
  expanded: false
};